<template>
<form autocomplete="off">
  <div class="md-autocomplete-loading" v-show="isPromisePending">
    <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
  </div>
  <CrudToolbar :save="saveTeam" :form="form" :$v="$v" :formConfig="formConfig" :cancel="cancel"></CrudToolbar>

  <div class="md-layout">
    <grid-layout
      :layout.sync="formLayout"
      :col-num="12"
      :is-draggable="false"
      :is-resizable="false"
      :auto-size="false"
      :is-mirrored="false"
      :vertical-compact="true"
      :responsive="false"
      :margin="[10, 10]"
      :use-css-transforms="true"
    >
      <grid-item v-for="(slot, slotName, index) in formConfig.slots" :id="slotName"
                :x="slot.layout.x"
                :y="slot.layout.y"
                :w="slot.layout.w"
                :h="slot.layout.h"
                :i="slot.layout.i"
                :key="'griditem_'+ slotName + slot.layout.i"
      >
      <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content">
        <h3><span class="heading">{{slot.label}}</span></h3>Create a base record to enable this section.
      </div>
      <div v-else :key="slotName" class="vue-grid-item-content">
            <h3><span class="heading">{{slot.label}}</span></h3>
        <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">

          <CrudCheckbox
            v-if="field.type == 'checkbox'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>

          <CrudDatepicker
            v-else-if="field.type == 'datepicker'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

          <CrudSelect
            v-else-if="field.type == 'select'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

          <CrudAutocomplete
            v-else-if="field.type == 'autocomplete'" :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

          <CrudJson
            v-else-if="field.type == 'json'" :key="name" class="field"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

          <!--
          <CrudText
            v-else :key="name"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.formConfig.fields" :field.sync="field"></CrudText>
            -->

          <CrudId
            v-else-if="field.type == 'id'" :key="name" class="field"
            :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

          <CrudText
            v-else :key="name" class="field"
              :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>

        </template>
      </div>
      <gridItemHook />

    </grid-item>
  </grid-layout>
  </div>
  <div v-show="scrollActive">
     <CrudToolbar :save="saveTeam" :form="form" :$v="$v" :formConfig="formConfig" :cancel="cancel"></CrudToolbar>
  </div>
</form>
</template>

<script>
  import RecordForm from '@/mixins/RecordForm';
  import VueGridLayout from 'vue-grid-layout';
  import Amplify, { Auth, API, graphqlOperation } from 'aws-amplify';
  import aws_exports from "../../aws-exports";
  import AWS from 'aws-sdk';

  const gridItemHook = {
    mounted(){
      // [i] This pushes each gridItem into this.gridItems below for config-form
      this.$parent.$parent.$parent.gridItems.push(this.$parent);
    },
    render(h){
      return h('div', [h('div',{attrs: {contentEditable: true, class: 'editable'}})])
    }
  };

  export default {
    name: "config-form",
    mixins: [RecordForm],
    components: {
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        gridItemHook
    },
    data () {
      return {
        formLayout: [//default value so that at least it works
          {"x":0,"y":0,"w":2,"h":2,"i":"0"},
          {"x":2,"y":0,"w":2,"h":4,"i":"1"},
          {"x":4,"y":0,"w":2,"h":5,"i":"2"},
          {"x":6,"y":0,"w":2,"h":3,"i":"3"},
          {"x":8,"y":0,"w":2,"h":3,"i":"4"},
          {"x":10,"y":0,"w":2,"h":3,"i":"5"},
          {"x":0,"y":5,"w":2,"h":5,"i":"6"},
          {"x":2,"y":5,"w":2,"h":5,"i":"7"},
          {"x":4,"y":5,"w":2,"h":5,"i":"8"},
          {"x":6,"y":4,"w":2,"h":4,"i":"9"},
          {"x":8,"y":4,"w":2,"h":4,"i":"10"},
          {"x":10,"y":4,"w":2,"h":4,"i":"11"},
          {"x":0,"y":10,"w":2,"h":5,"i":"12"},
          {"x":2,"y":10,"w":2,"h":5,"i":"13"},
          {"x":4,"y":8,"w":2,"h":4,"i":"14"},
          {"x":6,"y":8,"w":2,"h":4,"i":"15"},
          {"x":8,"y":10,"w":2,"h":5,"i":"16"},
          {"x":10,"y":4,"w":2,"h":2,"i":"17"},
          {"x":0,"y":9,"w":2,"h":3,"i":"18"},
          {"x":2,"y":6,"w":2,"h":2,"i":"19"}
        ],
        gridItems: [],
        scrollActive: false
      }
    },
    beforeMount() {
      let layout = [];
      this.$loopo(this.formConfig.slots, (slot) => {
        layout.push(slot.layout);
      });
      if (layout.length) {
        this.formLayout = layout;
      }
    },
    updated() {
      this.gridItems.forEach(gridItem => {
        gridItem.autoSize();
      });
    },
    methods: {
      handleScroll() {
        this.scrollActive = true;
      },
      async saveTeam(){
          this.isPromisePending = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
              this.$c.log('save(): unable to save, $v.invalid');
              return;
          }
          let data = {};
          const form = this.form;
          const fields = this.formConfig.fields;

          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (typeof form[name] !== 'undefined' && form[name] !== null) {
                if (field.type === 'datepicker') {
                  try{
                    data[name] = form[name].toUTCString();
                  }catch (e) {
                    data[name] = form[name].toString();
                    console.log('datepicker try catch ',form[name])
                  }
                } else {
                  data[name] = form[name];
                }
              }
            } else {
              if (field.type === 'json') {
                  data[name] = JSON.stringify(form[name].fields);
              }
            }
          });

          // We should not send any empty strings on create
          if (this.formConfig.pageMode == 'new') {
            this.$loopo(fields, (field, name) => {
              if (!field.fields) {
                if (data[name] === "") {
                  delete data[name];
                }
              } else {
                if (field.type === 'json') {
                  let isEmpty = true;
                  this.$loopo(field.fields, (ffield, fname) => {
                    let formValue = form[name].fields[fname];
                    if (formValue !== '') {
                      isEmpty = false;
                    }
                  });
                  if (isEmpty) {
                    delete data[name];
                  }
                }
              }
            });
          }

          if (this.formConfig.pageMode == 'edit') {
            this.$loopo(fields, (field, name) => {
              if (!field.fields) {
                if (data[name] === "") {
                  data[name] = null;
                }
              } else {
                if (field.type === 'json') {
                  let isEmpty = true;
                  this.$loopo(field.fields, (ffield, fname) => {
                    let formValue = form[name].fields[fname];
                    if (formValue !== '') {
                      isEmpty = false;
                    }
                  });
                  if (isEmpty) {
                    data[name] = null;
                  }
                }
              }
            });
          }

          this.$c.log('data has been prepared form=',data);
          
          if (this.formConfig.pageMode == 'new') {
              var params = {
                GroupName: data.name.replace(/\s+/g, '_'), /* required */
                UserPoolId: aws_exports.aws_user_pools_id, /* required */
              };
              Promise.resolve(Auth.currentAuthenticatedUser())
                .then(user =>
                  Auth.currentCredentials()
                      .then(credentials =>
                        Promise.resolve(
                          new AWS.CognitoIdentityServiceProvider({
                            apiVersion: '2016-04-18',
                            credentials: Auth.essentialCredentials(credentials),
                            region: aws_exports.aws_appsync_region
                          })
                        )
                      )
                      .then(client => {
                        client.createGroup(params).promise().then(groupRecord => {
                            console.log('Responce of create group', groupRecord);
                            data.cognito_groupid = groupRecord.Group.GroupName;
                            this.addData(data);
                        });
                        
                      })
                )
  
          } else {
              this.addData(data);
          }
        },
        async addData (data) {
          
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByFieldName');
          if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
            data[updatedByFieldName] = this.$reduce(this, '$Session.userId');
          }
          
          let query = this.getMutation(this.formConfig.pageMode === 'edit'? this.formConfig.actions.update : this.formConfig.actions.save);
          const result = await API.graphql(graphqlOperation(query, {input: data}))
            .then(result => {
              let responseKey = (this.formConfig.pageMode === 'new'? 'create' : 'update') + this.formConfig.objectName;
              let responseId = result.data[responseKey].id
              this.$c.log("success! responseKey = " + responseKey);
              this.$c.log("success! responseId = " + responseId);

              //if (this.pageMode == 'new') {
              this.$router.push(this.formConfig.listPath + '/' + responseId);
              //} else {
              // covered with watch now
              this.loadData(result.data[responseKey]);

              this.formConfig.pageMode = 'view';
              this.isPromisePending = false;
              // }
            })
            .catch(error => {
              this.$c.log(error);
            });
        }

    },
    mounted () {
        this.$nextTick(() => {
            if (typeof this.$route.params.id === 'undefined') {
              this.formConfig.fields.name.preventEdit = false;
            }else{
              setTimeout(() => {
                console.log('Update team form fields');
                this.formConfig.fields.name.preventEdit = true;
                // this.$v.form.cognito_groupid.$model = this.$v.form.cognito_groupid.$model.replace(/_/g, " ");
              }, 1200);
            } 
        });
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  };
</script>

<style lang="scss">
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {
    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

 .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }
</style>
